import { type TiptapDisplayProps, TiptapDisplay } from "@skyltmax/ds9"
import cn from "classnames"
import React from "react"
import StaticContent from "../../common/components/static_content"

const StaticTiptapDisplay: React.FC<TiptapDisplayProps> = props => {
  return (
    <StaticContent className={cn("ds9-tiptap-display", props.className)}>
      <TiptapDisplay fragment {...props} />
    </StaticContent>
  )
}

export default StaticTiptapDisplay
